var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class PrefixedFirebaseWrapper {
    constructor(firebase, prefix) {
        this.firebase = firebase;
        this.prefix = prefix;
    }
    idPath(path) {
        return this.prefix + '/' + path;
    }
    onValue(path, callback) {
        return this.firebase.onValue(this.idPath(path), callback);
    }
    onChildAdded(path, callback) {
        return this.firebase.onChildAdded(this.idPath(path), callback);
    }
    onChildChanged(path, callback) {
        return this.firebase.onChildChanged(this.idPath(path), callback);
    }
    onChildRemoved(path, callback) {
        return this.firebase.onChildRemoved(this.idPath(path), callback);
    }
    set(path, value) {
        return this.firebase.set(this.idPath(path), value);
    }
    get(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.firebase.get(this.idPath(path));
        });
    }
    onDisconnect(path) {
        return this.firebase.onDisconnect(this.idPath(path));
    }
    remove(path) {
        return this.firebase.remove(this.idPath(path));
    }
    runTransaction(path, transactionUpdate, options) {
        return this.firebase.runTransaction(this.idPath(path), transactionUpdate, options);
    }
    update(path, values) {
        return this.firebase.update(this.idPath(path), values);
    }
}
//# sourceMappingURL=PrefixedFirebaseWrapper.js.map